module.exports = __webpack_public_path__ + "static/01-e9b99dbf71ddd44e38585d4283bac033.jpg";